
import React from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface SidebarButtonProps {
  expanded: boolean;
  toggleSidebar: () => void;
  borderClass: string;
}

const SidebarButton = ({ expanded, toggleSidebar, borderClass }: SidebarButtonProps) => {
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon"
          onClick={toggleSidebar}
          className={`h-10 w-10 rounded-md border ${borderClass}`}
        >
          {expanded ? (
            <ChevronLeft className="h-4 w-4" />
          ) : (
            <ChevronRight className="h-4 w-4" />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">
        <p>{expanded ? "Collapse sidebar" : "Expand sidebar"}</p>
      </TooltipContent>
    </Tooltip>
  );
};

export default SidebarButton;
